function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#545454",
  strokeLinejoin: "square",
  fill: "#FFF",
  cx: "20",
  cy: "20",
  r: "19.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.522 20.522a.522.522 0 01-.094-1.035l.094-.009h2.623a8.87 8.87 0 018.334-8.333V8.522a.522.522 0 011.034-.094l.009.094v2.623a8.87 8.87 0 018.333 8.334h2.623a.522.522 0 01.094 1.034l-.094.009h-2.623a8.87 8.87 0 01-8.334 8.333v2.623a.522.522 0 01-1.034.094l-.009-.094v-2.623a8.87 8.87 0 01-8.333-8.334H8.522zM20 12.174a7.826 7.826 0 100 15.652 7.826 7.826 0 000-15.652zm0 3.652a4.174 4.174 0 110 8.348 4.174 4.174 0 010-8.348zm0 1.044a3.13 3.13 0 100 6.26 3.13 3.13 0 000-6.26z",
  fill: "#545454"
}))));